import React, { useState } from 'react';
import axios from 'axios';

const RegistrationForm = () => {
  const [formData, setFormData] = useState({
    azienda: '',
    referente: '',
    email: '',
    telefono: '',
    categoria: 15,
    attivo_dis: 1
  });

  const [message, setMessage] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [privacyAccepted, setPrivacyAccepted] = useState(false);
  const [isFormVisible, setIsFormVisible] = useState(true);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleOpenModal = (e) => {
    e.preventDefault();
    setShowModal(true); 
  };

  const handleAcceptPrivacy = async () => {
    setPrivacyAccepted(true);
    setShowModal(false); 

    try {
      const response = await axios.post('https://leadgen.networkgtc.it//api/register', formData);
      setMessage(response.data.message);
      setIsFormVisible(false); 
    } catch (error) {
      setMessage(error.response?.data?.message || 'Errore durante la registrazione!');
    }
  };

  const handleRejectPrivacy = () => {
    setPrivacyAccepted(false);
    setShowModal(false); 
    setMessage('Devi accettare la privacy per completare la registrazione.');
  };

  return (
    <div className="form-container">
    
      {isFormVisible ? (
        <form className="formRegistration" onSubmit={handleOpenModal}>
          <label>
            Azienda:
            <br />
            <input
              type="text"
              name="azienda"
              value={formData.azienda}
              onChange={handleChange}
              required
            />
          </label>
          <br />
          <label>
            <span>Referente</span>
            <br />
            <span style={{ fontSize: 'small' }}>(Nome e Cognome):</span>
            <br />
            <input
              type="text"
              name="referente"
              value={formData.referente}
              onChange={handleChange}
              required
            />
          </label>
          <br />
          <label>
            Email:
            <br />
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </label>
          <br />
          <label>
            Telefono:
            <br />
            <input
              type="tel"
              name="telefono"
              value={formData.telefono}
              onChange={handleChange}
              required
            />
          </label>
          <br />
          <button className="button1" type="submit">Invia</button>
        </form>
      ) : (
     
        <p className="endMessage">{message}</p>
      )}

  
      {showModal && (
        <div className="modal">
          <div className="modal-content">
            <h2>Privacy Policy</h2>
            <p style={{ textAlign: 'initial', padding: '1%' }}>
            Il sottoscritto dichiara, inoltre, di non aver assolto a più di un terzo del
                                proprio obbligo
                                formativo mediante reclutamento. *ai sensi dell’art. 80 dell’Accordo S/R del 2
                                febbraio 2017 si
                                intende reclutato il professionista sanitario che, per la partecipazione ad
                                eventi formativi,
                                beneficia di vantaggi economici e non economici, diretti ed indiretti, da parte
                                di imprese
                                commerciali operanti in ambito sanitario

                                TUTTI I CAMPI SONO OBBLIGATORI PER AVERE DIRITTO AI CREDITI FORMATIVI ECM E’
                                NECESSARIO COMPILARE IN
                                OGNI SUA PARTE IL PRESENTE QUESTIONARIO E CONSEGNATO DIRETTAMENTE AL TERMINE DEL
                                CORSO NON SARANNO
                                VALUTATI DOCUMENTI NON CONFORMI A QUELLI CONSEGNATI SUCCESSIVAMENTE AL TERMIBE
                                DELL’EVENTO.

                                PER COMPLETARE LA COMPILAZIONE DELLA SCHEDA ANAGRAFICA E’ NECESSARIO IL CONSENSO
                                AL TRATTAMENTO DEI
                                DAT PERSONALI.

                                Ai sensi del decreto legislativo 196/03 art. 7, 13 si informa che tutti i dati
                                raccolti con la
                                presente scheda saranno utilizzati dal provider per l’invio di informazioni su
                                iniziative,
                                manifestazione per l’invio di informazioni su iniziative, manifestazioni e fini
                                statistici. Gli
                                interessati possono chiedere la visione, la correzione e la cancellazione dei
                                propri dati ai sensi
                                del citato D.lgs. Il titolare del trattamento dei dati è il provider nella
                                persona del legale
                                rapp.te p.t.. Il trattamento effettuato anche con mezzi informatici e i suoi
                                dati sono conservati
                                presso gli uffici della sede del provider.
            </p>
            <div className="modal-buttons">
              <button className="button1" onClick={handleAcceptPrivacy}>Accetto</button>
              <button className="button1" onClick={handleRejectPrivacy}>Non Accetto</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default RegistrationForm;
